export default () => ({
  title: "",
  cities:[],
  issuedCities:[],
  birthCities:[],
  city:null,
  provinces:[],
  province:"",
  cityToEdit: '',
  status: '',
  total: "",
});
